<template>
  <div class="form-item">
    <form-checkbox :id="id" :title="title" :disabled="disabled">
      <slot />
    </form-checkbox>
    <slot name="info" />
    <div v-if="postfix" class="postfix">{{ postfix }}</div>
  </div>
</template>

<script>
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
export default {
  components: {
    FormCheckbox,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    postfix: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
div[disabled] {
  pointer-events: auto !important;
}
</style>
